import {
  AccountCircle,
  HelpOutlineOutlined,
  KeyboardArrowDownOutlined,
  NotificationsOutlined,
} from '@mui/icons-material'
import { Avatar, Badge, Box, Menu, MenuItem, Tooltip } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { useAuth } from 'contexts/auth'
import { Fragment, MouseEvent, useState } from 'react'
import { useHistory } from 'react-router-dom'
import api from 'services/api'
import ChangeOrganizationModal from '../change-organization-modal'
import HelpModal from '../help-modal'
import { useStyles } from './styles'

const UserInfo = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [openHelpMenu, setOpenHelpMenu] = useState<boolean>(false)
  const [openOrganizationModal, setOpenOrganizationModal] = useState<boolean>(false)

  const classes = useStyles()
  const history = useHistory()
  const { signOut, user } = useAuth()

  const { data: unreadResp } = useQuery({
    queryKey: ['notifications', 'unread-count'],
    queryFn: () => api.post('/notifications/count', { search: '', unreadOnly: true }),
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    enabled: !!user,
  })
  const unreadCount: number = unreadResp?.data?.data?.count ?? 0

  const menuId = 'account-menu'
  const isMenuOpen = Boolean(anchorEl)
  const isConduccoUser = user && user.email == 'admin@conducco.com'

  const avatarSx = {
    bgcolor: 'white',
    height: 41,
    width: 36,
    marginLeft: '10px',
    cursor: 'pointer',
  }

  const handleMenuClose = () => setAnchorEl(null)

  const handleProfile = () => {
    history.push('/profile')
    setAnchorEl(null)
  }

  const handleNavigateToNotifications = () => {
    history.push('/notifications')
    setAnchorEl(null)
  }

  const handleProfileMenuOpen = (event: MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget)

  const handleResetForTest = async () => {
    try {
      await api.delete('/conducco-cdp-accounts/drop-demo')
      alert('Banco resetado com sucesso!')
    } catch (error) {
      console.log(error)
    }
  }

  const handleOpenHelpMenu = () => {
    setOpenHelpMenu((prev) => !prev)
    setAnchorEl(null)
  }

  const handleOpenChangeOrgModal = () => {
    setOpenOrganizationModal((prev) => !prev)
    setAnchorEl(null)
  }

  if (user == null) {
    return null
  }

  return (
    <Fragment>
      <Box
        display='flex'
        alignItems='center'
        justifyContent='center'
        gap={2}
        paddingRight='0.5rem'
      >
        <Badge
          variant='dot'
          color='primary'
          invisible={unreadCount === 0}
          style={{ cursor: 'pointer' }}
          onClick={handleNavigateToNotifications}
        >
          <NotificationsOutlined
            scale={20}
            style={{ opacity: '0.6' }}
          />
        </Badge>

        <Tooltip
          title='Ajuda'
          PopperProps={{
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, -10],
                },
              },
            ],
          }}
        >
          <div className={classes.helpIconBox}>
            <HelpOutlineOutlined
              scale={20}
              className={classes.helpIcon}
              onClick={handleOpenHelpMenu}
            />
          </div>
        </Tooltip>
        <Box
          display='flex'
          alignItems='center'
          justifyContent='center'
        >
          <Box className={classes.userDetails}>
            <h1>{user?.name}</h1>
            <span>{user?.email}</span>
          </Box>
          <Box
            display='flex'
            alignItems='center'
            justifyContent='center'
            onClick={handleProfileMenuOpen}
          >
            <Avatar sx={avatarSx}>
              {user.avatar_url ? (
                <img
                  src={user.avatar_url}
                  className={classes.appIcon}
                />
              ) : (
                <AccountCircle className={classes.appIcon} />
              )}
            </Avatar>
            <KeyboardArrowDownOutlined
              scale={20}
              className={classes.arrowDownIcon}
            />
          </Box>
        </Box>
      </Box>

      <HelpModal
        openModal={openHelpMenu}
        setOpenModal={handleOpenHelpMenu}
      />

      <ChangeOrganizationModal
        openModal={openOrganizationModal}
        setOpenModal={handleOpenChangeOrgModal}
      />

      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        id={menuId}
        keepMounted
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={isMenuOpen}
        onClose={handleMenuClose}
        sx={{
          '& .MuiMenu-list': {
            padding: '0px',
          },
        }}
      >
        {isConduccoUser && <MenuItem onClick={handleResetForTest}>Resetar Banco</MenuItem>}
        {/* <MenuItem onClick={handleProfile}>Perfil</MenuItem> */}
        <MenuItem onClick={handleOpenChangeOrgModal}>Mudar Organização</MenuItem>
        <MenuItem onClick={signOut}>Sair</MenuItem>
      </Menu>
    </Fragment>
  )
}

export default UserInfo
